











































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import appconst from '@/lib/appconst';
import warehouseCity from '@/store/entities/warehouse-city';
import warehouseInfo from '@/store/entities/warehouseInfo';
import Enums from '@/lib/enums'
class AddModel {
    storeName: string;
    storeAddress: string;
    contactName: string;
    contactPhone: string;
    remark: string;
    onlyOneShelfCost?: number;
    deductIntegral?: number;
    deductionCycle?: number;
    beginDeductionTime?: Date;
}
@Component
export default class EditPackage extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    model: AddModel = new AddModel();
    siteType = Enums.SiteSType;
    addLoding = false;
    warehouseCityId: number = 0;
    logisticsChannelType = Enums.LogisticsChannelType;
    warehouseCityList: Array<warehouseCity> = [];
    warehouseInfoList: Array<warehouseInfo> = [];
    returnsTimeVal: string = "";
    async edit() {

        this.addLoding = true;
        await this.$store.dispatch({
            type: 'backstoreaddress/Edit',
            data: this.model
        }).finally(() => {
            this.addLoding = false;
        });
        (this.$refs.editForm as any).resetFields();
        this.$emit('save-success');
        this.$emit('input', false);

    }
    created() {

    }
    cancel() {
        (this.$refs.editForm as any).resetFields();
        this.$emit('input', false);
    }

    visibleChange(value: boolean) {
        if (!value) {
            this.$emit('input', value);
        } else {
            var data = this.$store.state.backstoreaddress.StoreAddresss;
            this.$set(this.model, "id", data.id);
            this.$set(this.model, "storeName", data.storeName);
            this.$set(this.model, "storeAddress", data.storeAddress);
            this.$set(this.model, "contactName", data.contactName);
            this.$set(this.model, "contactPhone", data.contactPhone);
            this.$set(this.model, "remark", data.remark);
            this.$set(this.model, "onlyOneShelfCost", data.onlyOneShelfCost);
            this.$set(this.model, "deductIntegral", data.deductIntegral);
            this.$set(this.model, "deductionCycle", data.deductionCycle);
            this.$set(this.model, "beginDeductionTime", data.beginDeductionTime);
        }
    }

}
